import axiosInstance from "../../../services/axiosInstance";
import { STATUSES } from "./apiStatus";
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

export const sent = createAsyncThunk(
  "sent/fetch",
  async (pageNumber, { rejectWithValue, serializeError }) => {
    try {
      const response = await axiosInstance.post(`/EsignServices/GetEsignLog?page=${pageNumber}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(serializeError(error));
    }
  },
  {
    serializeError: (err) => err.message,
  }
);

const sentSlice = createSlice({
  name: "sent",
  initialState: {
    data: {},
    status: "idle",
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(sent.pending, (state, action) => {
        state.status = STATUSES.LOADING;
      })
      .addCase(sent.fulfilled, (state, action) => {
        state.data = action.payload;
        state.status = STATUSES.IDLE;
      })
      .addCase(sent.rejected, (state, action) => {
        state.status = STATUSES.ERROR;
      });
  },
});

export default sentSlice.reducer;
